import type { ButtonProps } from '@vitvio/design-system';
import { Button, Text, useTheme } from '@vitvio/design-system';

/**
 * @deprecated This component is deprecated. Use the Button component from @vitvio/design-system directly instead.
 */
interface PrimaryButtonProps extends ButtonProps {
  text: string;
  onClickFn: () => void;
}

/**
 * @deprecated This component is deprecated. Use the Button component from @vitvio/design-system directly instead.
 * This component will be removed in a future version.
 */
export const PrimaryButton = (props: PrimaryButtonProps) => {
  const { text, onClickFn, ...buttonProps } = props;
  const { getColor } = useTheme();
  return (
    <Button
      bg={getColor('button.bg.primary')}
      color={getColor('fg.inverted')}
      onClick={onClickFn}
      _hover={{ bg: getColor('button.bg.primary.hover') }}
      _active={{ bg: getColor('button.bg.primary.active') }}
      {...buttonProps}
    >
      <Text color={getColor('fg.inverted')} path={text} />
    </Button>
  );
};
